import { Card } from '@outdoorsyco/bonfire';

import { EscapeTileCTA } from './EscapeTileCTA';
import { EscapeTileDescription } from './EscapeTileDescription';

interface TEscapeTileContentProps {
  location: string;
  name: string;
  lowestPrice: number;
  presentmentCurrency: string;
  slug: string;
}

export const EscapeTileContent = ({
  location,
  name,
  lowestPrice,
  presentmentCurrency,
  slug,
}: TEscapeTileContentProps) => {
  return (
    <Card.Content className="flex flex-col justify-between mt-5 gap-5">
      <EscapeTileDescription
        location={location}
        name={name}
        lowestPrice={lowestPrice}
        presentmentCurrency={presentmentCurrency}
      />
      <EscapeTileCTA slug={slug} name={name} />
    </Card.Content>
  );
};
